/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/segments_config" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiSegmentsConfig } from "./constants";
import type { CdiSegmentsConfig } from "./types";

export const getCdiSegmentsConfig = reactQueryFetcherAdapter(
  integrationsDirectCdiSegmentsConfig,
  (signal: AbortSignal): Promise<CdiSegmentsConfig[]> => {
    return fetch("/integrations/direct/cdi/segments_config", "GET", {}, { signal });
  }
);
